import { mapActions } from 'vuex'

export default {
  data () {
    return {
      status_options: [
        'pending',
        'active',
        'past_due',
        'suspended',
        'canceled',
        'deleted',
        'internal',
        'test'
      ],
      status_select_options: [
        { text: this.$t('organization.status.pending'), value: 'pending' },
        { text: this.$t('organization.status.active'), value: 'active' },
        { text: this.$t('organization.status.past_due'), value: 'past_due' },
        { text: this.$t('organization.status.suspended'), value: 'suspended' },
        { text: this.$t('organization.status.canceled'), value: 'canceled' },
        { text: this.$t('organization.status.deleted'), value: 'deleted' },
        { text: this.$t('organization.status.internal'), value: 'internal' },
        { text: this.$t('organization.status.test'), value: 'test' }
      ]
    }
  },
  methods: {
    ...mapActions({
      updateOrganizationStatus: 'organization/updateOrganizationStatus'
    }),
    getStatusObject (status) {
      switch (status) {
        case 'PENDING':
        case 'pending':
        case 1:
          return {
            color: 'blue-grey',
            fontWeight: '700',
            text: this.$t('organization.status.pending'),
            icon: 'schedule',
            value: 1
          }
        case 'ACTIVE':
        case 'active':
        case 2:
          return {
            color: 'green',
            fontWeight: '700',
            text: this.$t('organization.status.active'),
            icon: 'verified',
            value: 2
          }
        case 'PAST_DUE':
        case 'past_due':
        case 3:
          return {
            color: 'amber',
            fontWeight: '700',
            text: this.$t('organization.status.past_due'),
            icon: 'alarm',
            value: 3
          }
        case 'SUSPENDED':
        case 'suspended':
        case 4:
          return {
            color: 'orange',
            fontWeight: '700',
            text: this.$t('organization.status.suspended'),
            icon: 'block',
            value: 4
          }
        case 'CANCELED':
        case 'canceled':
        case 5:
          return {
            color: 'red',
            fontWeight: '700',
            text: this.$t('organization.status.canceled'),
            icon: 'cancel',
            value: 5
          }
        case 'DELETED':
        case 'deleted':
        case 6:
          return {
            color: 'grey',
            fontWeight: '700',
            text: this.$t('organization.status.deleted'),
            icon: 'delete',
            value: 6
          }
        case 'INTERNAL':
        case 'internal':
        case 7:
          return {
            color: 'grey',
            fontWeight: '700',
            text: this.$t('organization.status.internal'),
            icon: 'domain',
            value: 7
          }
        case 'TEST':
        case 'test':
        case 8:
          return {
            color: 'blue-grey',
            fontWeight: '700',
            text: this.$t('organization.status.test'),
            icon: 'schedule',
            value: 8
          }
        default:
          return {
            color: 'blue-grey',
            fontWeight: '700',
            text: this.$t('organization.status.pending'),
            icon: 'schedule',
            value: 1
          }
      }
    },
    changeStatus (status) {
      console.log(status)
      this.updateOrganizationStatus({
        id: this.organization.id,
        status
      }).then(res => {
        this.organization.status = status
      })
    }
  }
}
